import { useProfileManager } from '@/shared/hooks/useProfileManager';
import { AudioTrack, TextTrack } from '@/scenarios/legacy-player/types/instance';
import { useCurrentAudioTrack } from '@/scenarios/legacy-player/hooks/useCurrentAudioTrack';
import { useCurrentTextTrack } from '@/scenarios/legacy-player/hooks/useCurrentTextTrack';
import { useInstanceCallback } from '@/scenarios/legacy-player/hooks/useInstanceCallback';

import { useSetWatchParams } from '../../../../../movie-player/hooks/use-set-watch-params';

export const useSelectTrack = (contentId: string) => {
    const setWatchParams = useSetWatchParams();

    const currentTextTrack = useCurrentTextTrack();
    const currentAudioTrack = useCurrentAudioTrack();
    const currentSubtitlesLang = currentTextTrack?.lang;
    const audioLanguage = currentAudioTrack?.lang;

    const profileManager = useProfileManager();
    const transformedOttId = profileManager.userProfile?.ottId;

    const onAudioLangChange = useInstanceCallback(
        (instance, newTrack: AudioTrack) => {
            if (newTrack && instance) {
                instance.setAudioTrack(newTrack);
                setWatchParams({
                    audioLanguage: newTrack.lang,
                    subtitleLanguage: currentSubtitlesLang ?? null,
                    contentId,
                });
            }
        },
        [contentId, currentSubtitlesLang, transformedOttId]
    );

    const onSubtitlesLangChange = useInstanceCallback(
        (instance, newTrack: TextTrack) => {
            if (audioLanguage && instance) {
                instance.setTextTrack(newTrack);
                setWatchParams({
                    audioLanguage,
                    subtitleLanguage: newTrack?.lang ?? null,
                    contentId,
                });
            }
        },
        [audioLanguage, contentId, transformedOttId]
    );

    return { onAudioLangChange, onSubtitlesLangChange };
};
